import React from 'react';
import {Datagrid, List, TextField, ReferenceField, UrlField} from 'react-admin';
import {IReport} from '../../consts/Entities';
import {REPORTS, USER, COLUMN, STYLE_POST, ADMIN_LOGS} from '../../consts/Names';

export const ReportsList = (props: IReport) => {

   console.log(props)

   return (
      <List {...props} title="Reports" exporter={false} sort={{field: REPORTS.id, order: 'DESC'}}>
         <Datagrid>
            <TextField source={REPORTS.id} sortable={true} />
            
            <ReferenceField source={REPORTS.user_id} reference={USER.SOURCE} label="Report from">
               <TextField source={USER.username} />
            </ReferenceField>
            <TextField source={REPORTS.report} sortable={false} />

            <UrlField target={"_blank"} source={ADMIN_LOGS.link}  />


            
            <TextField source={REPORTS.created_at} sortable={false} />
         </Datagrid>
      </List>
   );
};
